<template>
    <div class="mt-4">
        <b-row>
            <b-col lg="12" md="12" sm="12">
                <div class="table-responsive">
                    <table class="table table-striped detail-table">
                        <tbody>
                        <template v-if="Object.keys(filtered_vital).length > 0">
                            <tr v-for="(row, index) in filtered_vital" :key="index">
                                <td class="detail-table-label">{{index | rowTitleFormat }}</td>
                                <td>{{row}}</td>
                            </tr>
                        </template>
                        <template v-else>
                            <tr>
                                <td colspan="2">No records found.</td>
                            </tr>
                        </template>
                        </tbody>
                    </table>
                </div>
            </b-col>
        </b-row>
    </div>
</template>

<script>
  import TableDataExcluder from '@/mixins/table-data-excluder';

  export default {
    props: {
      vital: {
        type: Object
      }
    },
    mixins: [TableDataExcluder],
    data() {
      return {
        excludeFields: ['id']
      }
    },
    computed: {
      filtered_vital() {
        return this.excluder(this.vital, this.excludeFields);
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/Appointment/Detail/Tabs/VitalTab.vue